<template>
  <!--我的会议-->
  <div class="content my-meeting">
    <div class="layui-fluid tab">
      <div class="layui-row">
        <div style="margin-left: 20px;margin-bottom:20px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/admin/MyMeeting' }">会议管理</el-breadcrumb-item>
            <el-breadcrumb-item>我的会议</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <el-tabs
        type="border-card"
        v-model="tab_name"
      >
        <el-tab-pane name="first">
          <span slot="label"><i class="el-icon-date"></i> 会议列表</span>
          <div class="layui-row">
            <div class="layui-col-md12">
              <!--下拉框-->
              <div
                class="layui-row top"
                style="margin-top:20px"
              >
                <!-- 我的会议搜索 START-->
                <div class="layui-col-md8">
                  <form
                    class="layui-form"
                    action
                    lay-filter="component-form-group"
                  >
                    <div class="layui-col-md5">
                      <div class="layui-form-item">
                        <div class="layui-inline">
                          <label
                            class="layui-form-label"
                            style="margin-right:20px"
                          >会议类型:</label>
                          <div class="layui-input-inline">
                            <select
                              name="modules"
                              lay-verify="required"
                              lay-filter="test"
                            >
                              <option value>全部</option>
                              <option value="1">会议</option>
                              <option value="2">沙龙</option>
                              <option value="3">活动</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="layui-col-md5">
                      <div class="layui-form-item">
                        <label class="layui-form-label">会议名称:</label>
                        <div class="layui-input-block">
                          <input
                            type="text"
                            name="title"
                            required
                            lay-verify="required"
                            placeholder="请输入会议名称"
                            autocomplete="off"
                            class="layui-input"
                            v-model="meet_name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="layui-col-md1 layui-col-md-offset1">
                      <el-button
                        type="primary"
                        @click="meet_sou"
                      >搜索</el-button>
                    </div>
                  </form>
                </div>
                <!-- 我的会议搜索 END-->
                <!-- 新增会议 START -->
                <div class="layui-col-md2 layui-col-md-offset1 the-meeting">
                  <router-link :to="{path:'/admin/AnewMeeting'}">
                    <el-button type="primary">新建会议</el-button>
                  </router-link>
                </div>
                <!-- 新增会议 END -->
              </div>
            </div>
            <h5 style="font-size:18px;margin-left:20px">会议列表</h5>
            <!--会议列表-->
            <loading-tip :show-load="loading"></loading-tip>
            <div
              v-show="fromation=='' && !loading"
              style="width: 100%;
          text-align: center;
        padding: 40px 0px;
        color: #bab1b1;"
            >无相关数据！</div>
            <div
              v-show="!loading"
              v-for="(item,index) in fromation"
              :key="index"
            >
              <div
                class="layui-row top"
                style="border-bottom: 1px solid #ccc;padding-bottom: 20px;margin-bottom: 20px;margin-left:20px"
              >
                <div class="layui-col-md8">
                  <div class="layui-row">
                    <div class="layui-col-md3 layui-col-xs6">
                      <div class="img_left meeting_img">
                        <img
                          :src="item.cover_url"
                          alt
                          width="100%"
                          style="border: 1px solid #ccc;display: block;height:150px"
                        />
                        <div
                          v-if="item.publish=='待发布'"
                          style="background-color: #99CC00;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >待发布</div>
                        <div
                          v-if="item.publish=='报名中'"
                          style="background-color: #FFB800;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >报名中</div>
                        <div
                          v-if="item.publish=='会议中'"
                          style="background-color: #1E9FFF;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >会议中</div>
                        <div
                          v-if="item.publish=='已结束'"
                          style="background-color: #000000;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >已结束</div>
                        <div
                          v-if="item.publish=='已发布'"
                          style="background-color: #393D49;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >已发布</div>
                        <div
                          v-if="item.publish=='未到报名时间'"
                          style="background-color: #393D49;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >未到报名时间</div>
                        <div
                          v-if="item.publish=='会议待开始'"
                          style="background-color: #393D49;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >会议待开始</div>
                        <div
                          v-if="item.publish=='暂停发布'"
                          style="background-color: #67718f;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >暂停发布</div>
                        <div
                          v-if="item.publish=='报名已截止 会议待开始'"
                          style="background-color: #67718f;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >报名已截止 会议待开始</div>
                      </div>
                    </div>
                    <div class="layui-col-md layui-col-xs6">
                      <div style="margin-left: 60px">
                        <h5 class="layui-elip">
                          {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-tag
                            type="danger"
                            size="medium"
                            v-show="item.parallel==1"
                          >平行会议</el-tag>
                        </h5>
                        <p class="layui-elip">{{item.specific_address}}</p>
                        <p class="layui-elip">{{item.start_time | dateformat('YYYY.MM.DD HH:mm')}}~{{item.end_time | dateformat('YYYY.MM.DD HH:mm')}}</p>
                        <p class="layui-elip">{{item.organizers}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="layui-col-md4 shiyan"
                  v-if="item.publish!=''"
                >
                  <div style="margin-top: 10px">
                    <div>
                      <el-button
                        type="primary"
                        @click="handleEdit(item.id)"
                        size="medium"
                      >编辑</el-button>
                    </div>
                    <div
                      v-if="item.publish=='待发布'"
                      style="margin-top: 10px"
                    >
                      <el-button
                        type="primary"
                        @click="handleRelease(item.id)"
                        size="medium"
                      >发布</el-button>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button
                        type="primary"
                        @click="handleCheckTheDetails(item.id)"
                        size="medium"
                      >查看详情</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-if="item.publish=='会议中'||item.publish=='已结束'||item.publish=='未到报名时间'||item.publish=='会议待开始'||item.publish=='报名中' ||item.publish=='已发布'"
                    >
                      <el-button
                        type="primary"
                        @click="handleSuspendRegistration(item.id)"
                        size="medium"
                      >暂停发布</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-if="item.publish=='暂停发布'"
                    >
                      <el-button
                        type="primary"
                        @click="handleContinueToRelease(item.id)"
                        size="medium"
                      >继续发布</el-button>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button
                        type="primary"
                        @click="yonghu(item.id)"
                        size="medium"
                      >排座位</el-button>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button
                        type="primary"
                        size="medium"
                        @click="quxiank(item.id)"
                      >权限控制</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--分页-->
          <div style="display: flex;
             justify-content: center;">
            <el-pagination
              @current-change="handleCurrentChanges"
              :current-page="cur"
              :page-sizes="[8]"
              :page-size="8"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalPage"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label"><i class="el-icon-share"></i> 分享会议</span>
          <div class="layui-row">
            <div class="layui-col-md12">
              <!--下拉框-->
              <div
                class="layui-row top"
                style="margin-top:20px"
              >
                <!-- 分享会议列表搜索 START-->
                <div class="layui-col-md8">
                  <form
                    class="layui-form"
                    action
                    lay-filter="component-form-group"
                  >
                    <div class="layui-col-md5">
                      <div class="layui-form-item">
                        <label class="layui-form-label">会议名称:</label>
                        <div class="layui-input-block">
                          <input
                            type="text"
                            name="title"
                            required
                            lay-verify="required"
                            placeholder="请输入会议名称"
                            autocomplete="off"
                            class="layui-input"
                            v-model="fxmeet_name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="layui-col-md1 layui-col-md-offset1">
                      <el-button
                        type="primary"
                        @click="fxsearch"
                      >搜索</el-button>
                    </div>
                  </form>
                </div>
                <!-- 分享会议列表搜索 END-->
              </div>
            </div>
            <h5 style="font-size:18px;margin-left:20px">分享会议列表</h5>
            <!--分享会议列表-->
            <loading-tip :show-load="loading"></loading-tip>
            <div
              v-show="fromations=='' && !loading"
              style="width: 100%;
           text-align: center;
           padding: 40px 0px;
           color: #bab1b1;"
            >无相关数据！</div>
            <div
              v-show="!loading"
              v-for="(item,index) in fromations"
              :key="index"
            >
              <div
                class="layui-row top"
                style="border-bottom: 1px solid #ccc;padding-bottom: 20px;margin-bottom: 20px;margin-left:20px"
              >
                <div class="layui-col-md8">
                  <div class="layui-row">
                    <div class="layui-col-md3 layui-col-xs6">
                      <div class="img_left meeting_img">
                        <img
                          :src="item.cover_url"
                          alt
                          width="100%"
                          style="border: 1px solid #ccc;display: block;height:150px"
                        />
                        <div
                          v-if="item.status_str=='待发布'"
                          style="background-color: #99CC00;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >待发布</div>
                        <div
                          v-if="item.status_str=='报名中'"
                          style="background-color: #FFB800;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >报名中</div>
                        <div
                          v-if="item.status_str=='会议中'"
                          style="background-color: #1E9FFF;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >会议中</div>
                        <div
                          v-if="item.status_str=='已结束'"
                          style="background-color: #000000;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >已结束</div>
                        <div
                          v-if="item.status_str=='已发布'"
                          style="background-color: #393D49;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >已发布</div>
                        <div
                          v-if="item.status_str=='未到报名时间'"
                          style="background-color: #393D49;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >未到报名时间</div>
                        <div
                          v-if="item.status_str=='会议待开始'"
                          style="background-color: #393D49;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >会议待开始</div>
                        <div
                          v-if="item.status_str=='暂停发布'"
                          style="background-color: #67718f;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >暂停发布</div>
                        <div
                          v-if="item.status_str=='报名已截止 会议待开始'"
                          style="background-color: #67718f;height: 34px;line-height: 34px;"
                          class="layui-btn layui-btn-xs inthemeeting meeting_img_text"
                        >报名已截止 会议待开始</div>
                      </div>
                    </div>
                    <div class="layui-col-md layui-col-xs6">
                      <div style="margin-left: 60px">
                        <h5 class="layui-elip">
                          {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-tag
                            type="danger"
                            size="medium"
                            v-show="item.parallel==1"
                          >平行会议</el-tag>
                        </h5>
                        <p class="layui-elip">{{item.specific_address}}</p>
                        <p class="layui-elip">{{item.start_time | dateformat('YYYY.MM.DD HH:mm')}}~{{item.end_time | dateformat('YYYY.MM.DD HH:mm')}}</p>
                        <p class="layui-elip">{{item.organizers}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="layui-col-md4">
                  <div
                    class="shiyan"
                    v-for="(it,i) in item.auth"
                    :key="it.id"
                  >
                    <div
                      v-show="it.name=='编辑会议'"
                      style="margin-top: 10px"
                    >
                      <el-button
                        type="primary"
                        @click="handleEdit(item.id)"
                        size="medium"
                      >编辑</el-button>
                    </div>
                    <div
                      v-show="it.name=='发布会议' && item.status_str=='待发布'"
                      style="margin-top: 10px"
                    >
                      <el-button
                        type="primary"
                        @click="handleRelease(item.id)"
                        size="medium"
                      >发布</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-show="it.name=='查看详情'"
                    >
                      <el-button
                        type="primary"
                        @click="handleCheckTheDetails(item.id)"
                        size="medium"
                      >查看详情</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-show="it.name=='发布会议' && item.status_str!=='暂停发布' && item.status_str!=='待发布'"
                    >
                      <el-button
                        type="primary"
                        @click="handleSuspendRegistration(item.id)"
                        size="medium"
                      >暂停发布</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-show="it.name=='发布会议' && item.status_str=='暂停发布'"
                    >
                      <el-button
                        type="primary"
                        @click="handleContinueToRelease(item.id)"
                        size="medium"
                      >继续发布</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-show="it.name=='排座位'"
                    >
                      <el-button
                        type="primary"
                        @click="yonghu(item.id)"
                        size="medium"
                      >排座位</el-button>
                    </div>
                    <div
                      style="margin-top: 10px"
                      v-show="it.name=='分享权限'"
                    >
                      <el-button
                        type="primary"
                        size="medium"
                        @click="quxiank(item.id)"
                      >权限控制</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex;
             justify-content: center;">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="onepage"
              :page-sizes="[8]"
              :page-size="8"
              layout="total, sizes, prev, pager, next, jumper"
              :total="onetotal"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import loadingTip from "../LoadingTip/loadingTip";
export default {
  name: "MyMeeting",
  data () {
    return {
      /* 分享分页 */
      onepage: 1, //当前页码
      onetotal: 0,//全部条数
      /* 分享搜索 */
      fxmeet_name: "",
      /* tab切换名 */
      tab_name: "first",
      loading: false,
      /* 会议列表 */
      fromation: [],
      /* 分享会议列表 */
      fromations: [],
      /* 会议列表分页 */
      cur: 1, //当前页码
      totalPage: 0, //全部条数
      type_meet: "",
      meet_name: ""
    };
  },
  components: { loadingTip },
  computed: {
  },
  created () {
    // 1.会议列表
    if (this.$route.query.cur)
    {
      this.cur = this.$route.query.cur;
      this.tab_name = this.$route.query.tab_name
    }
    this.initMeetingInformation();
    this.initMeetingInformations();
  },
  methods: {
    /* 权限控制 */
    quxiank (myId) {
      sessionStorage.setItem("conferenceId", myId);
      var _this = this
      _this.$router.push({
        path: "/admin/Authoritycontrol",
        query: { editId: myId, cur: _this.cur, tab_name: _this.tab_name },
      });
    },
    /* 分享会议分页 */
    handleCurrentChange (val) {
      var _this = this
      _this.onepage = val
      _this.initMeetingInformations()
    },
    /* 会议列表分页 */
    handleCurrentChanges (val) {
      var _this = this
      _this.cur = val
      _this.initMeetingInformation()
    },
    /* 排座位 */
    yonghu (ids) {
      sessionStorage.setItem("conferenceId", ids);
      var _this = this;
      _this.$router.push({
        path: "/admin/Zuowei",
        query: {
          id: ids,
          cur: _this.cur,
          tab_name: _this.tab_name
        },
      });
    },
    //编辑
    handleEdit (myid) {
      sessionStorage.setItem("conferenceId", myid);
      var isAdmin = JSON.parse(localStorage.getItem("conferenceAUserinfo")).is_admin;
      if(isAdmin == '1'){
        this.$router.push({
          path: "/admin/AnewMeeting",
          query: { editId: myid },
        });
      }else{
        this.$message({
              message: "抱歉，只有管理员可以进行该操作",
              type: "error",
              duration: 1000,
            });
      } 
    },
    // 发布
    handleRelease (myid) {
      sessionStorage.setItem("conferenceId", myid);
      var _this = this;
      let url = _this.APIurl.API.api.fabu;
      let params = {
        id: myid,
        status: 1,
      };
      this.$post(url, params)
        .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.$message({
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.initMeetingInformation();
            this.initMeetingInformations();
          } else
          {
            layer.msg(res.msg);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    //暂停发布
    handleSuspendRegistration (myid) {
      sessionStorage.setItem("conferenceId", myid);
      var _this = this;
      let url = _this.APIurl.API.api.fabu;
      let params = {
        id: myid,
        status: 2,
      };
      this.$post(url, params)
        .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.$message({
              message: "已暂停发布",
              type: "success",
              duration: 1000,
            });

            this.initMeetingInformation();
            this.initMeetingInformations();
          } else
          {
            layer.msg(res.msg);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    //查看详情
    handleCheckTheDetails (myid) {
      sessionStorage.setItem("conferenceId", myid);
      var _this = this;
      _this.$router.push({
        path: "/admin/MeetingDetails",
        query: { editId: myid, cur: _this.cur, tab_name: _this.tab_name },
      });
    },
    //继续发布
    handleContinueToRelease (myid) {
      sessionStorage.setItem("conferenceId", myid);
      var _this = this;
      let url = _this.APIurl.API.api.fabu;
      let params = {
        id: myid,
        status: 1,
      };
      _this
        .$post(url, params)
        .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.$message({
              message: "继续发布",
              type: "success",
              duration: 1000,
            });
            _this.initMeetingInformation();
            _this.initMeetingInformations();
          } else
          {
            layer.msg(res.msg);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    // 会议列表
    initMeetingInformation () {
      var _this = this;
      let url = this.APIurl.API.api.meeting_list;
      let params = {
        pagesize: "8", //每页条数
        page: _this.cur, //当前页
      };
      this.loading = true;
      this.$get(url, params)
        .then((res) => {
          if (parseInt(res.code) === 1)
          {
            this.fromation = res.posts.list;
            this.totalPage = res.posts.count;
            this.cur = res.posts.page;
            // this.all = Math.ceil(
            //   (((res.posts.count * 1000) / res.posts.pagesize) * 1000) / 1000000
            // );
          } else
          {
            layer.msg(res.msg);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /* 分享会议 */
    initMeetingInformations () {
      var _this = this;
      let url = _this.APIurl.API.api.fenxianglist;
      let params = {
        pagesize: 8, //每页条数
        page: _this.onepage, //当前页
        name: _this.fxmeet_name
      };
      this.loading = true;
      this.$get(url, params)
        .then((res) => {
          console.log(res);
          if (parseInt(res.code) === 1 && res.posts != "")
          {
            this.fromations = res.posts.list;
            this.onetotal = res.posts.count
            this.onepage = res.posts.page
          } else
          {
            this.fromations = ""
            console.log(res.msg);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /* 分享搜索 */
    fxsearch () {
      this.initMeetingInformations()
    },
    /* 搜索 */
    meet_sou (index) {
      var _this = this;
      let url = this.APIurl.API.api.meeting_list;
      let params = {
        pagesize: "5", //每页条数
        page: 1, //当前页
        type: this.type_meet,
        name: this.meet_name,
      };
      this.loading = true;
      this.$get(url, params)
        .then((res) => {
          if (parseInt(res.code) === 1)
          {
            this.fromation = res.posts.list;

            for (let i = 0; i < this.fromation.length; i++)
            {
              this.$set(this.fromation[i], "release", true);
              this.$set(this.fromation[i], "registration", false);
              this.$set(this.fromation[i], "meeting", false);
              this.$set(this.fromation[i], "hasEnded", false);
              this.$set(this.fromation[i], "registrations", false);
              this.$set(this.fromation[i], "continueToRelease", false);
              this.$set(this.fromation[i], "details", false);
              this.$set(this.fromation[i], "suspended", false);
            }
            this.totalPage = res.posts.count;
            this.cur = res.posts.page;
            this.all = Math.ceil(
              (((res.posts.count * 1000) / res.posts.pagesize) * 1000) / 1000000
            );
          } else
          {
            layer.msg(res.msg);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 会议列表结束
    // 公共方法
    handlePublics () {
      var _this = this;
      //注意：导航 依赖 element 模块，否则无法进行功能性操作
      layui.use(["element", "form"], function () {
        var element = layui.element;
        var form = layui.form;
        /* 监听下拉选择会议类型 */
        form.on("select(test)", function (data) {
          _this.type_meet = data.value;
        });
        //监听提交
        form.on("submit(formDemo)", function (data) {
          _this.$message({
            message: JSON.stringify(data.field),
            type: "success",
            duration: 1000,
          });
          return false;
        });
        element.render();
        form.render();
      });
    },
  },
  mounted () {
    // 公共方法
    this.handlePublics();
  },
  updated () {
    // 公共方法
    this.handlePublics();
  },
};
</script>

<style scoped>
.el-drawer:focus {
  outline: none;
}
li.router-link-exact-active {
  color: #8fc526 !important;
}
/*分页*/
.page-bar {
  margin: 40px auto;
  margin-top: 20px;
}
ul,
li {
  margin: 0px;
  padding: 0px;
}
li {
  list-style: none;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #5d6062;
  cursor: pointer;
  margin-right: 20px;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #009688;
  border-color: #009688;
}
.page-bar i {
  font-style: normal;
  color: #009688;
  margin: 0px 4px;
  font-size: 12px;
}
/*分页结束*/
.my-meeting {
  background: #ffffff;
}
.content .top {
  margin-top: 4px;
}
.content .layui-form-label {
  padding: 9px 0;
}
.my-meeting .img_left {
  position: relative;
}
.my-meeting .inthemeeting {
  position: absolute;
  left: 103px;
}
/* 列表图片 */
.meeting_img {
  position: relative;
}
/* 列表图片上的文字 */
.meeting_img_text {
  position: absolute;
  top: 1px;
  right: 1px;
  left: auto !important;
  padding: 0px 15px 0px 15px;
  border-radius: 0;
}

.shiyan {
  display: flex;
  align-items: center !important;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .my-meeting .the-meeting {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .my-meeting .layuiedit {
    margin-top: 10px;
  }
}
</style>
